import React from "react";

export default function CTISMemberStateOverlaysPage() {
  return (
    <>
      <h1 className="h3 mb-3">CTIS Members</h1>
      <p className="text-muted">Placeholder page for CTIS templates management.</p>
    </>
  );
}